function Loader(elem) {
    this._elem = elem;
    var that = this;
    this.show = function () {
        that._elem.removeClass('hidden');
    };

    this.hide = function () {
        that._elem.addClass('hidden');
    };
}